module.exports = __webpack_public_path__ + "img/8F5D3C_5B3B26_382416_70482E-256px.27fd9ce6.png";